import HttpService from '../baseHttp'


// 发运单模块

export const HttpShipBillList = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/findByPage', { params: data })
export const HttpShipBill = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/findOne', { params: data })
// 发运单头单据-保存/编辑
export const HttpSaveShipBillPlan = (data = {}, config) => HttpService.post('/api/v2/ShipmentPlan/savePlan', data)
// 发运单子单据和子单据产品行保存/编辑
export const HttpSaveShipBillItems = (data = {}, config) => HttpService.post('/api/v2/ShipmentPlan/saveItems', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 发运单提货信息
export const HttpSaveShipBillAddress = (data = {}, config) => HttpService.post('/api/v2/ShipmentPlan/savePick', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 更改单据状态
export const HttpUpdateShipBillStatus = (data = {}, config) => HttpService.post('/api/v2/ShipmentPlan/changeStatus', data)
// 删除发运单
export const HttpDeleteShipBill = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/deleteOne', { params: data })
// 发运单修改目的仓地址-发运中
export const HttpUpdateteShipBillAddress = (data = {}, config) => HttpService.post('/api/v2/ShipmentPlan/saveWarehouse', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 获取物流历史
export const HttpShipBillLogistic = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/getLogisticHistory', { params: data })
// 批量推送仓储
export const HttpPushShipBill = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/pushWarehouse', { params: data })
// 采购单号列表
export const HttpShipOBillList = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/findBySourceOrderNoLike', { params: data })
// 通过采购单号获取采购单信息
export const HttpShipOBillDataList = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/findBySourceOrderNos', { params: data })
//获取装箱信息
export const HttpShipOBillPacking = (data = {}, config) => HttpService.get('/api/v2/Inbound/getBoxItems', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpPackingGetNumber = (data = {}, config) => HttpService.get('/api/v2/Inbound/selectByOrgIdAndNo', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// 获取箱标url
export const HttpShipOBillPackingUrl = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/getPackingUrl', { params: data })
// 获取亚马逊仓地址code
export const HttpWareHouseCodeList = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/findWareHouseCode', { params: data })
// 导出
export const HttpExportShipBill = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/export', { params: data })
//批量推送中转
export const HttpTransferShipBill = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/pushTransfer', { params: data })
//发运明细条件列表查询
export const HttpTransferBillList = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/findOrderByPage', { params: data })
// 发运明细单条查询
export const HttpTransferBill = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/findOneByOrder', { params: data })
// 发运单单据复制
export const HttpCopyShipBill = (data = {}, config) => HttpService.get('/api/v2/ShipmentPlan/copyShipment', { params: data })
